// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--3B8gP"};